import React from "react"
import PropTypes from "prop-types"
import SocialIcon, { getSocialPlatform } from "components/elements/socialIcon"
import Col from "../../Col"
import "./social.scss"

// LinkedIn isn't in the Contentful footer links, so it's added here unless
// Contentful already has it.
const LINKEDIN = {
  path: "https://www.linkedin.com/company/cortica-care/",
  text: "LinkedIn",
}

const withLinkedIn = (links = []) =>
  links.some(link => getSocialPlatform(link.path, link.text) === "LinkedIn")
    ? links
    : [...links, LINKEDIN]

const Social = ({ socialLinks }) => (
  <div className="g-footer-social">
    <Col label="Follow Us">
      <ul>
        {withLinkedIn(socialLinks).map((link, i) => {
          const platform = getSocialPlatform(link.path, link.text)
          return (
            <li key={i}>
              {platform ? (
                <a
                  aria-label={`${platform} (opens in a new tab)`}
                  className="g-footer-social-icon"
                  href={link.path}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <SocialIcon name={platform} />
                </a>
              ) : (
                <a href={link.path}>{link.text}</a>
              )}
            </li>
          )
        })}
      </ul>
    </Col>
  </div>
)

Social.props = {
  socialLinks: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      text: PropTypes.string,
    })
  ),
}

Social.propTypes = Social.props

export default Social
